import Vue from 'vue'

const state = {
    stockLoss: {
        cashier: {},
        items: [],
        reason: '',
        cfop: '5929'
    },
    stockLosses: [],
}
const actions = {
    showStockLosses: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/stock-losses`).then(response => {
                context.commit('SHOW_STOCK_LOSSES', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showStockLoss: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/stock-losses/${id}`).then(response => {
                context.commit('SHOW_STOCK_LOSS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeStockLoss: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/stock-losses`, payload).then(response => {
                context.commit('STORE_STOCK_LOSS', response.data)
                Vue.$toast.info('Baixa de estoque registrada com sucesso!')
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateStockLoss: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/stock-losses/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyStockLoss: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/stock-losses/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {
    SHOW_STOCK_LOSS: (state, payload) => {
        state.stockLoss = payload
    },
    SHOW_STOCK_LOSSES: (state, payload) => {
        state.stockLosses = payload
    },
    STORE_STOCK_LOSS: (state, payload) => {
        state.stockLoss = payload
    }
}
const getters = {
    stockLoss: state => {
        return state.stockLoss
    },
    stockLosses: state => {
        return state.stockLosses
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
